if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;

    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }

    return null;
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
} // ————————————————————————————————————————————————————————————————————————————


var Modal = function Modal(options) {
  if (options === undefined) options = {};
  this.options = extend({}, {
    onClose: null,
    onOpen: null,
    beforeOpen: null,
    beforeClose: null,
    closeMethods: ['overlay', 'escape']
  }, options);
  this.init();
};

Modal.prototype.init = function () {
  var _this = this;

  this.parents = [];
  document.addEventListener('click', function (event) {
    if (!event.target.matches('.js-popup')) return;
    event.preventDefault();
    event.stopPropagation();
    var parent = event.target.closest('.popup');

    if (parent && parent !== undefined) {
      _this.parents.push(parent);

      parent.classList.remove('popup--opened');
    } else if (_this.modal !== undefined) {
      _this.close();
    }

    _this.link = event.target;

    _this.open(_this.link.getAttribute('href'));
  }, false);
  document.addEventListener('click', function (event) {
    if (!event.target.matches('.js-popup-close')) return;
    event.preventDefault();
    event.stopPropagation();

    _this.close();
  }, false);

  if (this.options.closeMethods.indexOf('escape') !== -1) {
    document.addEventListener('keydown', function (event) {
      if (event.which === 27 && _this.modal !== undefined) {
        _this.close();
      }
    });
  }

  if (window.location.hash.length && window.location.hash !== '#' && this.modal === undefined && document.querySelector('a.js-popup[href="' + window.location.hash + '"]')) {
    // click(document.querySelector('a[href="'+window.location.hash+'"]'))
    _this.open(window.location.hash);
  }

  if (this.options.closeMethods.indexOf('overlay') !== -1) {
    document.addEventListener('click', function (event) {
      if (!event.target.matches('.popup') && !event.target.matches('.popup__container')) return;
      if (!event.isTrusted) return;

      _this.close();
    });
  }
};

Modal.prototype.open = function (id) {
  var _open = true;

  if (this.modal !== undefined) {
    this.close();
  }

  this.modal = document.querySelector(id);

  if (typeof this.options.beforeOpen === 'function') {
    _open = this.options.beforeOpen(this.modal, this.link, this.parents);
  }

  if (!_open) return;
  document.documentElement.classList.add('lock');
  document.documentElement.style.marginRight = getScrollbarWidth() + 'px';
  this.modal.classList.add('popup--opened');
  this.changeUrl('#' + this.modal.getAttribute('id'));

  if (typeof this.options.onOpen === 'function') {
    this.options.onOpen(this.modal, this.link, this.parents);
  }
};

Modal.prototype.close = function () {
  var _close = true;

  if (typeof this.options.beforeClose === 'function') {
    _close = this.options.beforeClose(this.modal, this.link, this.parents);
  }

  if (!_close) return;
  this.modal.classList.remove('popup--opened');

  if (typeof this.options.onClose === 'function') {
    this.options.onClose(this.modal, this.link, this.parents);
  }

  if (this.parents.length) {
    this.modal = this.parents.pop();
    this.modal.classList.add('popup--opened');
    this.changeUrl('#' + this.modal.getAttribute('id'));
  } else {
    document.documentElement.classList.remove('lock');
    document.documentElement.style.marginRight = 0 + 'px';
    this.modal = undefined;
    this.link = undefined;
    this.changeUrl('#');
  }
};

Modal.prototype.changeUrl = function (hash) {
  if (history.pushState) {
    window.history.pushState(null, null, hash);
  } else {
    window.location.hash = hash;
  }
};

Modal.prototype.handleKeyboard = function (event) {
  document.addEventListener('keydown', function (event) {
    if (event.which === 27 && this.modal !== undefined) {
      this.close();
    }
  });
};

Modal.prototype.handleOverlay = function (event) {
  document.addEventListener('mousedown', function (event) {
    if (event.target.matches('.js-popup')) return;
    this.close();
  });
}; // ------------------------------------------------------------------------
// helpers


function extend() {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (arguments[i].hasOwnProperty(key)) {
        arguments[0][key] = arguments[i][key];
      }
    }
  }

  return arguments[0];
}

function getScrollbarWidth() {
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = "scroll";
  var inner = document.createElement("div");
  inner.style.width = "100%";
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}

function click(node) {
  if (document.createEvent) {
    var evt = document.createEvent('MouseEvents');
    evt.initEvent('click', true, false);
    node.dispatchEvent(evt);
  } else if (document.createEventObject) {
    node.fireEvent('onclick');
  } else if (typeof node.onclick === 'function') {
    node.onclick();
  }
}

window.modal = new Modal({
  closeMethods: ['escape']
});